import RestService from '../../services/RestService';
import ConfigActionType from '../../common/ConfigActionType';
import HomeAction from '../../redux/actions/HomeAction';

const plansConfigUri = '/api/v1/product/frontendConfig';
const staticConfigUri = '/api/v1/configuration';

const storePlansConfig = () => dispatch =>
  RestService.get(plansConfigUri).then(
    (response) => {
      dispatch({ type: ConfigActionType.STORE_PLANS_CONFIG, config: response.entity });
    },
    (error) => {
      dispatch(HomeAction.storeError(error));
    }
  );

const storeStaticConfig = () => dispatch =>
  RestService.get(staticConfigUri).then(
    (response) => {
      dispatch({ type: ConfigActionType.STORE_STATIC_CONFIG, config: response.entity });
    },
    (error) => {
      dispatch(HomeAction.storeError(error));
    }
  );

export default {
  storePlansConfig,
  storeStaticConfig
};



/** WEBPACK FOOTER **
 ** ./src/redux/actions/ConfigAction.js
 **/